import React, { useState } from "react";
import {
  TextField,
  FormControlLabel,
  Checkbox,
  Box,
  Typography,
} from "@mui/material";
import {
  Google as GoogleIcon,
  Microsoft as MicrosoftIcon,
} from "@mui/icons-material";
import { googleSignup, microsoftSignup } from "../../libs/firebase";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useLoginState } from "./LoginState";
import { getErrorMessage } from "../helper";
import { PrimaryButton, OutlineButton } from "../Button";
import { SigninContainer } from "./styles";
import PasswordField from "./SignupForm/PasswordField";
import { authRedirect } from "./utils";

export const SignInPage = (props) => {
  return <SignIn {...props} />;
};

export const SignIn = React.forwardRef((props, ref) => {
  const [showFlash, setShowFlash] = useState(false);
  const [flashMessage, setFlashMessage] = useState("Flash Message");
  const setShowLogin = useLoginState((state) => state.setShowLogin);
  const setOrCreateProfile = useLoginState((state) => state.setOrCreateProfile);
  const [emailValue, setEmailValue] = useState("");
  const [password, setPassword] = useState("");
  
  const auth = getAuth();

  const handleSubmit = (e?: React.FormEvent) => {
    if (e) {
      e.preventDefault();
    }
    
    if (!emailValue || !password) {
      setFlashMessage("Please enter all the required details");
      setShowFlash(true);
      return;
    }
    
    signInWithEmailAndPassword(auth, emailValue, password)
      .then(() => {
        setTimeout(() => {
          setShowLogin(null);
          if (authRedirect(window.location.pathname)) {
            return;
          }
        }, 100);
      })
      .catch((error) => {
        setShowFlash(true);
        let errMsg = getErrorMessage(error.message);
        errMsg = errMsg + " - If you need help contact studio@mattoboard.com";
        setFlashMessage(errMsg);
      });
  };

  const handleOAuthSignin = (signupFunction: () => Promise<any>) => {
    signupFunction()
      .then((result: any) => {
        setOrCreateProfile(result, true).then(() => {
          setShowLogin(null);
          if (authRedirect(window.location.pathname)) {
            return;
          }
        });
      })
      .catch((error) => {
        setShowFlash(true);
        let errMsg = getErrorMessage(error.message);
        errMsg = errMsg + " - If you need help contact studio@mattoboard.com";
        setFlashMessage(errMsg);
      });
  };
  const onChangeEmail = (e) => {
    setEmailValue(e.target.value.replace(/\s/g, ""));
  };
  const onChangePassword = (e) => {
    setPassword(e.target.value);
  };

  return (
    <SigninContainer>
      <Box className="form-root">
        <Box sx={{ display: { xs: "block", md: "none" } }}>
          <img
            src={"/images/mattoboard-logo.jpg"}
            alt="MattoBoard"
            className="logo-img"
          />
          <Typography component="h1" variant="h5" className="login-title">
            Sign in To Continue
          </Typography>
        </Box>

        {showFlash && (
          <Typography
            sx={{ fontSize: "1rem" }}
            component="h6"
            color="error"
            align="center"
            variant="h5"
          >
            {flashMessage}
          </Typography>
        )}
        <form className="login-form" onSubmit={handleSubmit}>
          <TextField
            size="small"
            style={{ height: "0.5em", paddingBottom: "15px" }}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            type="email"
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={emailValue}
            onChange={onChangeEmail}
          />
          <PasswordField
            name="password"
            label="Password"
            value={password}
            onChange={onChangePassword}
          />
          <Box className="forgot-root">
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
              className="remember-check"
            />
            <Box className="signup-link" sx={{ marginTop: "2px" }}>
              <button
                type="button"
                className="signup-btn"
                style={{ color: "blue", fontWeight: "400" }}
                onClick={() => setShowLogin("forgot")}
              >
                Forgot password? Reset
              </button>
            </Box>
          </Box>

          <PrimaryButton fullWidth variant="contained" type="submit">
            Sign In
          </PrimaryButton>

          <OutlineButton
            onClick={() => handleOAuthSignin(googleSignup)}
            fullWidth
            variant="outlined"
            className="google-btn"
            style={{ marginTop: "25px", marginBottom: "3px" }}
          >
            <GoogleIcon sx={{ color: "#453B41" }} />
            <span>Sign In With Google</span>
          </OutlineButton>
          
          <OutlineButton
            onClick={() => handleOAuthSignin(microsoftSignup)}
            fullWidth
            variant="outlined"
            className="google-btn"
          >
            <MicrosoftIcon sx={{ color: "#4285F4" }} />
            <span>Sign In With Microsoft</span>
          </OutlineButton>

          <Box className="signup-link" style={{ marginTop: "14px" }}>
            <Typography className="signup-text">New user?</Typography>
            <button
              type="button"
              className="signup-btn"
              onClick={() => setShowLogin("signup")}
              style={{ color: "blue", fontWeight: "400" }}
            >
              Create an account
            </button>
          </Box>
        </form>
      </Box>
    </SigninContainer>
  );
});
